import Vue from 'vue'
import Vuex from 'vuex'
import { api } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    color: '#FF2F89',
    loading: false,
    works: [],
    worksLoaded: false,
    windowSize: {
      width: 0,
      height: 0
    }
  },
  getters: {
    works: (state) => {
      return state.works;
    },
    worksLoaded: (state) => {
      return state.worksLoaded;
    },
    getNextBySlug: (state, getters) => (slug) => {
      const index = state.works.findIndex(x => x.slug === slug);
      if(index > -1) {
        return (index + 1 > getters.works.length - 1) ? getters.works[0] : getters.works[index + 1];
      } else {
        return false;
      }
    }
  },
  mutations: {
    setColor: (state, color) => {
      state.color = color;
    },
    loading: (state, loading) => {
      state.loading = loading;
    },
    setWorks: (state, data) => {
      state.works = data;
      state.worksLoaded = true;
    },
    setWindowSize: (state, w, h) => {
      state.windowSize.width = w;
      state.windowSize.height = h;
    }
  },
  actions: {
    getWorks({commit, state}) {
      return api.getWorks()
        .then(res => {
          commit('setWorks', res.data.data);
        })
        .catch(error => {
          console.log(error.message);
        })
    }
  }
})
